import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import { Grid } from '@mui/material'
import DatePicker from '../../../../components/forms/DatePicker'
import Input from '../../../../components/forms/Input'
import Select from '../../../../components/forms/Select'
import Textarea from '../../../../components/forms/Textarea'
import { getDefaultValuesChoiceModal, getMatTypes } from '../../../../utils/MaterielUtils'
import DtoSimType from '../dto/DtoSimType'
import SimDto from '../dto/SimDto'

const SimEquipmentPanel = ({
    active = false,
    disabled = true,
    sim = {},
    simTypes = [],
    onChange = () => { },
}) => (
    <Grid size={12} sx={{ marginBottom: 1 }}>
        <Grid container sx={{ paddingTop: '3px' }}>
            <Grid size={4}>
                <Select
                    options={getMatTypes(simTypes, sim.simType)}
                    label={i18n.type}
                    onChange={value => {
                        onChange({ simType: value })
                        getDefaultValuesChoiceModal(simTypes.find(c => c.materielType == value), onChange)
                    }}
                    value={sim.simType}
                    nullLabel='&nbsp;'
                    active={active}
                    disabled={disabled}
                />
            </Grid>
        </Grid>
        <Grid container spacing={1} sx={{ paddingTop: '3px' }}>
            <Grid size={4}>
                <DatePicker
                    onChange={(_, v) => onChange({ enableDate: v })}
                    id='enableDate'
                    title={i18n.activationDate}
                    value={sim.enableDate}
                    active={active}
                    disabled={disabled}
                    startDate={sim.purchaseDate}
                    endDate={sim.disableDate}
                />
            </Grid>
            <Grid size={4}>
                <DatePicker
                    onChange={(_, v) => onChange({ disableDate: v })}
                    id='disableDate'
                    title={i18n.closingLine}
                    value={sim.disableDate}
                    active={active}
                    disabled={disabled}
                    startDate={sim.enableDate}
                />
            </Grid>
            {
                sim.disableDate && (
                    <Grid size={4}>
                        <Input
                            title={i18n.closeCause}
                            value={sim.explanationDisable}
                            onChange={value => onChange({ explanationDisable: value })}
                            active={active}
                            disabled={disabled}
                        />
                    </Grid>
                )
            }
        </Grid>
        <Grid container sx={{ paddingTop: '8px' }}>
            <Grid size={12}>
                <Textarea
                    title={i18n.comment}
                    value={sim.comment}
                    onChange={value => onChange({ comment: value })}
                    active={active}
                    disabled={disabled}
                />
            </Grid>
        </Grid>
    </Grid>
)

SimEquipmentPanel.propTypes = {
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    onChange: PropTypes.func,
    sim: PropTypes.instanceOf(SimDto),
    simTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoSimType)),
}

const mapStateToProps = store => ({
    simTypes: store.SimReducer.simTypes,
})

export default connect(mapStateToProps)(SimEquipmentPanel)
